module.exports = __webpack_public_path__ + "img/icon_contacts.81955644.png";